import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import Container from './Container';
import { useLocation } from 'react-router-dom'; // Importe o hook useLocation
import styles from './PageLayout.module.css';

function PageLayout({ title, children, links }) {
    const location = useLocation();
    const shouldShowTitle = location.pathname !== '/';

    return (
        <div className={styles.pageLayout}>
            <Navbar links={links} /> {/* Passa os links dinamicamente */}
            <div className={styles.pageBody}>
                {shouldShowTitle && <h2 className={styles.pageTitle}>{title}</h2>}
                <Container customClass="centerContent">
                    <div className={styles.pageContent}>
                        {children}
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
}

export default PageLayout;
